// wait until condition is true and call callback, on error call callback with truthy first parameter
App.namespace('es6.shared.waitFor', () => (condition, callback, { interval = 50, attempts = Infinity } = {}) => {

  let tries = 0;

  function check() {
    tries += 1;

    if (condition()) {
      callback();
      return;
    }

    if (tries >= attempts) {
      callback(true);
      return;
    }

    setTimeout(check, interval);
  }

  check();
});
